import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfLiveMissionAction = createAsyncThunk(
    'live-mission',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/live-mission?s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfLiveMissionSlice = createSlice({
    name: 'live-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfLiveMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfLiveMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfLiveMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfLiveMissionReducer = noOfLiveMissionSlice.reducer